import "../10. Battle/Library/LibraryBoxBattle.scss";
import "./BattleStatisticsDialog.scss";
import NP from "../1. Core/NP";
import Label from "../1. Core/Controls/Label/Label";
import Button from "../1. Core/Controls/Button/Button";
import BattleStatisticsDialogBase from "./BattleStatisticsDialogBase";

export default class BattleStatisticsDialog extends BattleStatisticsDialogBase {

	_initFields(settings: object)
	{
		this._CurrentBattleEvents = [];
		this._AllBattleEvents = [];
		this._Tournament = '';
		this._TournamentId = 0;
		this._Stage = '';
		this._Round = 1;
		this._LastEditedRound = 1;
		this._TimeSegmentIndex = 0;
		this._LastEditedTimeSegmentIndex = 0;
		this._Sequence = 1;
		this._IsActionInSequence = false;
		this._Red = null;
		this._Blue = null;
		this._RedName = '';
		this._BlueName = '';
		this._ActionAthleteId = null;
		this._AnswerAthleteId = null;
		this._DialogMode = 0;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Width = 600;
		this._Caption = NP.RM.getString('BattleStatistics');
		this._CloseOnFrameMouseDown = false;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._ShowButtons = false;
		this._UseSinglePaddingContent = false;
		this._FlexContent = true;
		this._MaxRound = this._TournamentId < 0 ? 12 : 3;

	}

	_render()
	{
		super._render();
		this.addClass('nopad');
		this.addClass('battle-statistics-dialog');

		let boutInfoNode = NP.createNode(this._contentNode, 'bout-info');

//		let boutInfoNodeFirstRow = NP.createNode(boutInfoNode, 'bout-info__row');
//		let infoSectionLeft = NP.createNode(boutInfoNodeFirstRow, 'bout-info__row__section');
//	   let infoSectionRight = NP.createNode(boutInfoNodeFirstRow, 'bout-info__row__section');
// 		this._tournamentLabel = new Label({
// 			ParentNode: boutInfoNodeFirstRow,
// 			Class: 'bout-info__row__item',
// 			Content: this._Tournament
// 		});
// 		this._stageLabel = new Label({
// 			ParentNode: boutInfoNodeFirstRow,
// 			Class: 'bout-info__row__item bout-info__row__item--narrow',
// 			TextWrap: false,
// 			Content: this._Stage
// 		});
		let boutInfoNodeSecondRow = NP.createNode(boutInfoNode, 'bout-info__row');
		this._redLabel = new Label({
			ParentNode: boutInfoNodeSecondRow,
			Class: 'bout-info__row__item bout-info__row__item__red',
			MultiLine: true,
			Content: this._RedName
		});
		this._blueLabel = new Label({
			ParentNode: boutInfoNodeSecondRow,
			Class: 'bout-info__row__item bout-info__row__item__blue',
			MultiLine: true,
			Content: this._BlueName
		});
		let boutInfoNodeThirdRow = NP.createNode(boutInfoNode, 'bout-info__row');
		this._roundLabel = new Label({
			ParentNode: boutInfoNodeThirdRow,
			Class: 'bout-info__row__item',
		});
		this._timeSegmentLabel = new Label({
			ParentNode: boutInfoNodeThirdRow,
			Class: 'bout-info__row__item',
		});
		this._sequenceLabel = new Label({
			ParentNode: boutInfoNodeThirdRow,
			Class: 'bout-info__row__item',
		});

		let eventInfoNode = NP.createNode(this._contentNode, 'event-info');
		let eventInfoLeftSection = NP.createNode(eventInfoNode, 'event-info__section event-info__section__red');
		let eventInfoRightSection = NP.createNode(eventInfoNode, 'event-info__section event-info__section__blue');

//----------------------Strike sections----------------------------------------------------------------
		this._strikeRed = NP.createNode(eventInfoLeftSection, 'event-info__actions');
		let strikeRedSectionRow1 = NP.createNode(this._strikeRed, 'event-info__row');
		this._redJBtn = new Button({
			Content: NP.RM.getString('J'),
			Value: 'J',
			ParentNode: strikeRedSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Red, this._Blue, this._redJBtn)
		});
		this._redCBtn = new Button({
			Content: NP.RM.getString('C'),
			Value: 'C',
			ParentNode: strikeRedSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Red, this._Blue, this._redCBtn)
		});
		let strikeRedSectionRow2 = NP.createNode(this._strikeRed, 'event-info__row');
		this._redHLBtn = new Button({
			Content: NP.RM.getString('HL'),
			Value: 'HL',
			ParentNode: strikeRedSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Red, this._Blue, this._redHLBtn)
		});
		this._redHRBtn = new Button({
			Content: NP.RM.getString('HR'),
			Value: 'HR',
			ParentNode: strikeRedSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Red, this._Blue, this._redHRBtn)
		});
		let strikeRedSectionRow3 = NP.createNode(this._strikeRed, 'event-info__row');
		this._redULBtn = new Button({
			Content: NP.RM.getString('UL'),
			Value: 'UL',
			ParentNode: strikeRedSectionRow3,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Red, this._Blue, this._redULBtn)
		});
		this._redURBtn = new Button({
			Content: NP.RM.getString('UR'),
			Value: 'UR',
			ParentNode: strikeRedSectionRow3,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Red, this._Blue, this._redURBtn)
		});
		let strikeRedSectionRow4 = NP.createNode(this._strikeRed, 'event-info__row');
		this._redCLBtn = new Button({
			Content: NP.RM.getString('CL'),
			Value: 'CL',
			ParentNode: strikeRedSectionRow4,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () =>
			{
				this._setClinchAction(this._Red);
				this._applyBattleEvent({SetNextSequence: true});
			}
		});

		this._strikeBlue = NP.createNode(eventInfoRightSection, 'event-info__actions');
		let strikeBlueSectionRow1 = NP.createNode(this._strikeBlue, 'event-info__row');
		this._blueJBtn = new Button({
			Content: NP.RM.getString('J'),
			Value: 'J',
			ParentNode: strikeBlueSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Blue, this._Red, this._blueJBtn)
		});
		this._blueCBtn = new Button({
			Content: NP.RM.getString('C'),
			Value: 'C',
			ParentNode: strikeBlueSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Blue, this._Red, this._blueCBtn)
		});
		let strikeBlueSectionRow2 = NP.createNode(this._strikeBlue, 'event-info__row');
		this._blueHLBtn = new Button({
			Content: NP.RM.getString('HL'),
			Value: 'HL',
			ParentNode: strikeBlueSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Blue, this._Red, this._blueHLBtn)
		});
		this._blueHRBtn = new Button({
			Content: NP.RM.getString('HR'),
			Value: 'HR',
			ParentNode: strikeBlueSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Blue, this._Red, this._blueHRBtn)
		});
		let strikeBlueSectionRow3 = NP.createNode(this._strikeBlue, 'event-info__row');
		this._blueULBtn = new Button({
			Content: NP.RM.getString('UL'),
			Value: 'UL',
			ParentNode: strikeBlueSectionRow3,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Blue, this._Red, this._blueULBtn)
		});
		this._blueURBtn = new Button({
			Content: NP.RM.getString('UR'),
			Value: 'UR',
			ParentNode: strikeBlueSectionRow3,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setAnswerMode(this._Blue, this._Red, this._blueURBtn)
		});
		let strikeBlueSectionRow4 = NP.createNode(this._strikeBlue, 'event-info__row');
		this._blueCLBtn = new Button({
			Content: NP.RM.getString('CL'),
			Value: 'CL',
			ParentNode: strikeBlueSectionRow4,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () =>
			{
				this._setClinchAction(this._Blue);
				this._applyBattleEvent({SetNextSequence: true})
			}
		});
//--------------------Strike sections end---------------------------------------------------

//--------------------Answer sections----------------------------------------------------------------
		this._answerRed = NP.createNode(eventInfoLeftSection, 'event-info__actions');
		let answerRedSectionRow1 = NP.createNode(this._answerRed, 'event-info__row');
		this._redBBtn = new Button({
			Content: NP.RM.getString('B'),
			Value: 'B',
			ParentNode: answerRedSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._redBBtn.getValue()})
		});
		this._redNBtn = new Button({
			Content: NP.RM.getString('N'),
			Value: 'N',
			ParentNode: answerRedSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._redNBtn.getValue()})
		});
		let answerRedSectionRow2 = NP.createNode(this._answerRed, 'event-info__row');
		this._redUBtn = new Button({
			Content: NP.RM.getString('U'),
			Value: 'U',
			ParentNode: answerRedSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._redUBtn.getValue()})
		});
		this._redWBtn = new Button({
			Content: NP.RM.getString('W'),
			Value: 'W',
			ParentNode: answerRedSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._redWBtn.getValue()})
		});
		let answerRedSectionRow3 = NP.createNode(this._answerRed, 'event-info__row');
		this._redPBtn = new Button({
			Content: NP.RM.getString('P'),
			Value: 'P',
			ParentNode: answerRedSectionRow3,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setHitMode(this._redPBtn)
		});

		this._answerBlue = NP.createNode(eventInfoRightSection, 'event-info__actions');
		let answerBlueSectionRow1 = NP.createNode(this._answerBlue, 'event-info__row');
		this._blueBBtn = new Button({
			Content: NP.RM.getString('B'),
			Value: 'B',
			ParentNode: answerBlueSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._blueBBtn.getValue()})
		});
		this._blueNBtn = new Button({
			Content: NP.RM.getString('N'),
			Value: 'N',
			ParentNode: answerBlueSectionRow1,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._blueNBtn.getValue()})
		});
		let answerBlueSectionRow2 = NP.createNode(this._answerBlue, 'event-info__row');
		this._blueUBtn = new Button({
			Content: NP.RM.getString('U'),
			Value: 'U',
			ParentNode: answerBlueSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._blueUBtn.getValue()})
		});
		this._blueWBtn = new Button({
			Content: NP.RM.getString('W'),
			Value: 'W',
			ParentNode: answerBlueSectionRow2,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._blueWBtn.getValue()})
		});
		let answerBlueSectionRow3 = NP.createNode(this._answerBlue, 'event-info__row');
		this._bluePBtn = new Button({
			Content: NP.RM.getString('P'),
			Value: 'P',
			ParentNode: answerBlueSectionRow3,
			Class: 'app-button--outlined event-info__btn',
			EvClick: () => this._setHitMode(this._bluePBtn)
		});
//--------------------Answer sections end----------------------------------------------------------------

//--------------------Hit sections----------------------------------------------------------------
		this._hitRed = NP.createNode(eventInfoLeftSection, 'event-info__actions');
		let hitRedSectionRow1 = NP.createNode(this._hitRed, 'event-info__row hit__row');
		this._redP1Btn = new Button({
			Content: NP.RM.getString('P1Short'),
			Value: 'P1',
			ParentNode: hitRedSectionRow1,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._redP1Btn.getValue()})
		});
		let hitRedSectionRow1Col = NP.createNode(hitRedSectionRow1, 'hit__col');
		this._redP2Btn = new Button({
			Content: NP.RM.getString('P2Short'),
			Value: 'P2',
			ParentNode: hitRedSectionRow1Col,
			Class: 'app-button--outlined event-info__btn hit__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._redP2Btn.getValue()})
		});
		this._redP4Btn = new Button({
			Content: NP.RM.getString('P4Short'),
			Value: 'P4',
			ParentNode: hitRedSectionRow1Col,
			Class: 'app-button--outlined event-info__btn hit__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._redP4Btn.getValue()})
		});
		this._redP3Btn = new Button({
			Content: NP.RM.getString('P3Short'),
			Value: 'P3',
			ParentNode: hitRedSectionRow1,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._redP3Btn.getValue()})
		});
		NP.createNode(this._hitRed, 'event-info__row');
		let hitRedSectionRow2 = NP.createNode(this._hitRed, 'event-info__row hit__row');
		this._redP5Btn = new Button({
			Content: NP.RM.getString('P5Short'),
			Value: 'P5',
			ParentNode: hitRedSectionRow2,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._redP5Btn.getValue()})
		});
		this._redP6Btn = new Button({
			Content: NP.RM.getString('P6Short'),
			Value: 'P6',
			ParentNode: hitRedSectionRow2,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._redP6Btn.getValue()})
		});
		this._redP7Btn = new Button({
			Content: NP.RM.getString('P7Short'),
			Value: 'P7',
			ParentNode: hitRedSectionRow2,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._redP7Btn.getValue()})
		});




		this._hitBlue = NP.createNode(eventInfoRightSection, 'event-info__actions');
		let hitBlueSectionRow1 = NP.createNode(this._hitBlue, 'event-info__row hit__row');
		this._blueP1Btn = new Button({
			Content: NP.RM.getString('P1Short'),
			Value: 'P1',
			ParentNode: hitBlueSectionRow1,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._blueP1Btn.getValue()})
		});
		let hitBlueSectionRow1Col = NP.createNode(hitBlueSectionRow1, 'hit__col');
		this._blueP2Btn = new Button({
			Content: NP.RM.getString('P2Short'),
			Value: 'P2',
			ParentNode: hitBlueSectionRow1Col,
			Class: 'app-button--outlined event-info__btn hit__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._blueP2Btn.getValue()})
		});
		this._blueP4Btn = new Button({
			Content: NP.RM.getString('P4Short'),
			Value: 'P4',
			ParentNode: hitBlueSectionRow1Col,
			Class: 'app-button--outlined event-info__btn hit__btn',
			EvClick: () => this._applyBattleEvent({Answer: this._blueP4Btn.getValue()})
		});
		this._blueP3Btn = new Button({
			Content: NP.RM.getString('P3Short'),
			Value: 'P3',
			ParentNode: hitBlueSectionRow1,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._blueP3Btn.getValue()})
		});
		NP.createNode(this._hitBlue, 'event-info__row');
		let hitBlueSectionRow2 = NP.createNode(this._hitBlue, 'event-info__row  hit__row');
		this._blueP5Btn = new Button({
			Content: NP.RM.getString('P5Short'),
			Value: 'P5',
			ParentNode: hitBlueSectionRow2,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._blueP5Btn.getValue()})
		});
		this._blueP6Btn = new Button({
			Content: NP.RM.getString('P6Short'),
			Value: 'P6',
			ParentNode: hitBlueSectionRow2,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._blueP6Btn.getValue()})
		});
		this._blueP7Btn = new Button({
			Content: NP.RM.getString('P7Short'),
			Value: 'P7',
			ParentNode: hitBlueSectionRow2,
			Class: 'app-button--outlined event-info__btn hit__btn event-info__btn hit__btn--vert',
			EvClick: () => this._applyBattleEvent({Answer: this._blueP7Btn.getValue()})
		});


//--------------------Hit sections end----------------------------------------------------------------

		let actionButtonsNode = NP.createNode(this._contentNode, 'action-buttons');
		this._backBtn = new Button({
			Content: '',
			FontImage: NP.FontImages.arrow_back,
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this._onBackClick()
		});
		this._nextTimeSegmentBtn = new Button({
			RK: 'NextTimeSegment',
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this._setNextTimeSegment()
		});
		this._nextRoundBtn = new Button({
			RK: 'NextRound',
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this._setNextRound()
		});
		this._boutEndBtn = new Button({
			RK: 'BoutEnd',
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this._setBoutEnd()
		});
		this._overviewBtn = new Button({
			RK: 'Overview',
			ParentNode: actionButtonsNode,
			Class: 'action-buttons__btn',
			EvClick: () => this._openOverview()
		});

		this._historyNode = NP.createNode(eventInfoNode, 'events-history');

		this._spaceBtn = new Button({
			RK: 'Space',
			ParentNode: eventInfoNode,
			Class: 'app-button--outlined space-btn',
			EvClick: () => this._applySpace()
		});

		NP.hideNode(this._contentNode);


		this.createCriticalCB(eventInfoLeftSection, eventInfoRightSection);
	}

	_setAnswerMode(actionAthleteId: number, answerAthleteId: number, activeButton: Button)
	{
		this._DialogMode = 1;
		this._AnswerAthleteId = answerAthleteId;
		this._ActionAthleteId = actionAthleteId;
		this._ActiveStrikeButton = activeButton;
		this._Action = activeButton.getValue();

		NP.hide([this._AnswerAthleteId == this._Red ? this._strikeRed : this._strikeBlue, this._hitRed, this._hitBlue, this._spaceBtn]);
		NP.show([this._AnswerAthleteId == this._Red ? this._answerRed : this._answerBlue]);
		NP.setEnabled([this._backBtn, this._redBBtn, this._redNBtn, this._redUBtn, this._redWBtn, this._redPBtn, this._blueBBtn, this._blueNBtn, this._blueUBtn, this._blueWBtn, this._bluePBtn], true);
		NP.setEnabled([this._nextTimeSegmentBtn, this._nextRoundBtn, this._boutEndBtn], false);

		if (this._AnswerAthleteId == this._Red)
			this._disableBlueStrikeButtons();
		else
			this._disableRedStrikeButtons();

		this._ActiveStrikeButton.setEnabled(true);

		this._refreshHeader();
	}

	_setHitMode(activeButton: Button)
	{
		this._DialogMode = 2;
		this._ActiveAnswerButton = activeButton;

		NP.hide([this._AnswerAthleteId == this._Red ? this._hitRed : this._hitBlue, this._answerRed, this._answerBlue, this._spaceBtn]);
		NP.show(this._AnswerAthleteId == this._Red ? [this._hitRed, this._redKnockdownBtn, this._redStunningBtn] : [this._hitBlue, this._blueKnockdownBtn, this._blueStunningBtn]);
		NP.setEnabled([this._backBtn, this._redP1Btn, this._redP2Btn, this._redP3Btn, this._redP4Btn, this._redP5Btn, this._redP6Btn, this._redP7Btn, this._blueP1Btn, this._blueP2Btn, this._blueP3Btn, this._blueP4Btn, this._blueP5Btn, this._blueP6Btn, this._blueP7Btn], true);
		NP.setEnabled([this._nextTimeSegmentBtn, this._nextRoundBtn, this._boutEndBtn], false);

		if (this._AnswerAthleteId == this._Red)
			this._disableBlueHitButtons();
		else
			this._disableRedHitButtons();

		this._ActiveAnswerButton.setEnabled(true);

		this._refreshHeader();
	}

	_disableRedStrikeButtons()
	{
		this._redJBtn.setEnabled(false);
		this._redCBtn.setEnabled(false);
		this._redHLBtn.setEnabled(false);
		this._redHRBtn.setEnabled(false);
		this._redULBtn.setEnabled(false);
		this._redURBtn.setEnabled(false);
		this._redCLBtn.setEnabled(false);
	}

	_disableBlueStrikeButtons()
	{
		this._blueJBtn.setEnabled(false);
		this._blueCBtn.setEnabled(false);
		this._blueHLBtn.setEnabled(false);
		this._blueHRBtn.setEnabled(false);
		this._blueULBtn.setEnabled(false);
		this._blueURBtn.setEnabled(false);
		this._blueCLBtn.setEnabled(false);
	}

	_disableRedHitButtons()
	{
		this._redP1Btn.setEnabled(false);
		this._redP2Btn.setEnabled(false);
		this._redP3Btn.setEnabled(false);
		this._redP4Btn.setEnabled(false);
		this._redP5Btn.setEnabled(false);
		this._redP6Btn.setEnabled(false);
		this._redP7Btn.setEnabled(false);
	}

	_disableBlueHitButtons()
	{
		this._blueP1Btn.setEnabled(false);
		this._blueP2Btn.setEnabled(false);
		this._blueP3Btn.setEnabled(false);
		this._blueP4Btn.setEnabled(false);
		this._blueP5Btn.setEnabled(false);
		this._blueP6Btn.setEnabled(false);
		this._blueP7Btn.setEnabled(false);
	}
}